import React from 'react';
import { FormDrawer } from './FormDrawer';
import { CONTACT_SOURCE_OPTIONS } from '../../config/formConfigs';
import { normalizeProperCaseText } from '../../utils/textUtils';

const PROPER_CASE_CONTACT_FIELDS = new Set(['full_name', 'role']);

export const ContactsForm = ({
  isOpen,
  onClose,
  onSave,
  isSaving = false,
  isDarkMode = false,
  isEditing = false,
  formData,
  onChange,
  formError = '',
  organizationOptions = [],
  zIndex = 10000,
}) => {
  const handleChange = (field, value) => {
    onChange?.(field, value);
  };

  const handleBlurField = (field) => {
    if (!PROPER_CASE_CONTACT_FIELDS.has(field)) return;
    const current = formData?.[field];
    if (typeof current !== 'string') return;
    const normalized = normalizeProperCaseText(current);
    if (normalized !== current) {
      onChange?.(field, normalized);
    }
  };

  const sections = [
    {
      key: 'contact',
      title: 'Datos del contacto',
      fields: [
        { key: 'contact_code', label: 'Código', disabled: true, readOnly: true },
        {
          key: 'full_name',
          label: 'Nombre',
          type: 'custom',
          render: ({ value, onChange: onFieldChange, colors, baseInputStyle }) => (
            <label style={{ fontSize: '12px', color: colors.text, display: 'flex', flexDirection: 'column' }}>
              Nombre
              <input
                style={{ ...baseInputStyle, marginTop: '6px' }}
                value={value || ''}
                onChange={(event) => onFieldChange(event.target.value)}
                onBlur={() => handleBlurField('full_name')}
              />
            </label>
          ),
        },
        {
          key: 'role',
          label: 'Cargo',
          type: 'custom',
          render: ({ value, onChange: onFieldChange, colors, baseInputStyle }) => (
            <label style={{ fontSize: '12px', color: colors.text, display: 'flex', flexDirection: 'column' }}>
              Cargo
              <input
                style={{ ...baseInputStyle, marginTop: '6px' }}
                value={value || ''}
                onChange={(event) => onFieldChange(event.target.value)}
                onBlur={() => handleBlurField('role')}
              />
            </label>
          ),
        },
        { key: 'email', label: 'Email', type: 'email' },
        { key: 'linkedin', label: 'LinkedIn' },
        { key: 'phone', label: 'Teléfono' },
        {
          key: 'status',
          label: 'Estado',
          type: 'select',
          options: [
            { value: 'Activo', label: 'Activo' },
            { value: 'Inactivo', label: 'Inactivo' },
          ],
        },
        {
          key: 'source',
          label: 'Fuente',
          type: 'select',
          options: [{ value: '', label: 'Seleccionar fuente' }, ...CONTACT_SOURCE_OPTIONS],
        },
        {
          key: 'source_details',
          label: 'Fuente - Detalle',
          type: 'textarea',
          fullWidth: true,
          rows: 2,
          placeholder: 'Cuándo o dónde se conoció este contacto',
        },
      ],
    },
    {
      key: 'org',
      title: 'Organización',
      fields: [
        {
          key: 'organization_id',
          label: 'Organización',
          fullWidth: true,
          type: 'select',
          options: organizationOptions,
        },
      ],
    },
  ];

  return (
    <FormDrawer
      isOpen={isOpen}
      onClose={onClose}
      onSave={onSave}
      isSaving={isSaving}
      isDarkMode={isDarkMode}
      title={isEditing ? 'Editar Contacto' : 'Agregar Contacto'}
      subtitle="Formulario minimalista"
      sections={sections}
      formData={formData}
      onChange={handleChange}
      formError={formError}
      width={520}
      zIndex={zIndex}
    />
  );
};

export default ContactsForm;
